module.exports = "/assets/f2cfeeafa90788dd6e980728bfdb04e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TU.png
// module id = 2989
// module chunks = 0